import PosthogService from '~/services/posthog/PosthogService';
import { REDESIGN_SIGNUP_DESIGN_DATE } from '~/services/posthog/events';

/**
 * Fires when the user submits the Your Information step (Step 1).
 * Event: dental_portal:office_signup:contact_info_submitted
 */
export function fireContactInfoSubmitted(): void {
  PosthogService.getInstance().track('dental_portal:office_signup:contact_info_submitted', {
    design_date: REDESIGN_SIGNUP_DESIGN_DATE,
  });
}
